// extracted by mini-css-extract-plugin
export default {"entry-select--with-error":"components-settings-budget-forecast-modals-modal-copy-to-existing-module__entry-select--with-error"};